import { render } from "./BarcodeUnpairScan.vue?vue&type=template&id=6fc494af&scoped=true"
import script from "./BarcodeUnpairScan.vue?vue&type=script&lang=ts"
export * from "./BarcodeUnpairScan.vue?vue&type=script&lang=ts"

import "./BarcodeUnpairScan.vue?vue&type=style&index=0&id=6fc494af&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6fc494af"

export default script